import type { MealType } from "../api/diary";

export default function MealIcon({ meal, size = 32 }: { meal: MealType; size?: number }) {
  if (meal === "breakfast") {
    // Жёлто-оранжевое полусолнце с лучами + полоска-горизонт
    return (
      <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden>
        {/* Лучи */}
        <g stroke="#FF9800" strokeWidth="2" strokeLinecap="round">
          <line x1="16" y1="4" x2="16" y2="8" />
          <line x1="6" y1="9" x2="9" y2="11.5" />
          <line x1="26" y1="9" x2="23" y2="11.5" />
          <line x1="3" y1="17" x2="6.5" y2="17" />
          <line x1="29" y1="17" x2="25.5" y2="17" />
        </g>
        {/* Полусолнце */}
        <path d="M7.5 21 A8.5 8.5 0 0 1 24.5 21 Z" fill="#FFB74D" />
        {/* Горизонт */}
        <line x1="4" y1="24" x2="28" y2="24" stroke="#FF9800" strokeWidth="2" strokeLinecap="round" />
      </svg>
    );
  }
  if (meal === "lunch") {
    // Ярко-голубой круг с маленькими лучами вокруг
    return (
      <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden>
        <g stroke="#2196F3" strokeWidth="2" strokeLinecap="round">
          <line x1="16" y1="3" x2="16" y2="6" />
          <line x1="16" y1="26" x2="16" y2="29" />
          <line x1="3" y1="16" x2="6" y2="16" />
          <line x1="26" y1="16" x2="29" y2="16" />
          <line x1="6.5" y1="6.5" x2="8.6" y2="8.6" />
          <line x1="23.4" y1="23.4" x2="25.5" y2="25.5" />
          <line x1="6.5" y1="25.5" x2="8.6" y2="23.4" />
          <line x1="23.4" y1="8.6" x2="25.5" y2="6.5" />
        </g>
        <circle cx="16" cy="16" r="7" fill="#2196F3" />
      </svg>
    );
  }
  if (meal === "dinner") {
    // Розово-оранжевый полукруг солнца касающийся горизонта
    return (
      <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden>
        {/* Небо за горизонтом (полоска) */}
        <rect x="3" y="20" width="26" height="3" fill="#EC407A" rx="1.5" />
        {/* Полусолнце */}
        <path d="M7.5 21.5 A8.5 8.5 0 0 1 24.5 21.5 Z" fill="#FF7043" />
        {/* Горизонт */}
        <line x1="3" y1="24.5" x2="29" y2="24.5" stroke="#EC407A" strokeWidth="2" strokeLinecap="round" />
      </svg>
    );
  }
  // snack — фиолетовый полумесяц
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden>
      <path
        d="M24 20.5 A10 10 0 1 1 11.5 8 A7.5 7.5 0 0 0 24 20.5 Z"
        fill="#9575CD"
      />
    </svg>
  );
}
